<template>
    <div v-if="asyncDataStatus_ready">

    <v-row justify="space-between">
      <v-col cols="6" md="3">
        <v-text-field
          v-if="this.userTypes.length"
          placeholder="Išči..."
          append-icon="mdi-search"
          v-model="filter"
          @keydown.esc="filter=''"
        ></v-text-field>
      </v-col>
      <v-col cols="auto">
        <v-btn
          color="#0F998E"
          class="white--text"
          @click="$router.push({name: 'MyCompanyUserTypesNew'})"
        >
          Nov tip uporabnika
          <v-icon right dark>mdi-plus</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-row class="userTypes-wrapper" v-if="this.userTypes.length">
      <v-col
        md="4" lg="3" sm="12" xs="12"
        v-for="item of filteredUserTypes" :key="item.id"
      >
        <UserTypeCard
          :userType="item"
          @edit="$router.push({name: 'MyCompanyUserTypesEdit', params: {id: item.id}})"
          @delete="showDeleteUserTypeModal = true; deleteUserType = item"
        />
      </v-col>
    </v-row>
    <v-row
      v-else
    >
      <v-col cols="12">
        <p class="text-center">
          Ni rezultatov iskanja. Za dodajanje novega tipa uporabnika uporabite gumb desno zgoraj.
        </p>
      </v-col>
    </v-row>

    <ConfirmDialog
      title="Brisanje tipa uporabnika"
      text="Ali ste prepričani, da želite izbrisati tip uporabnika? Podatki bodo trajno izbrisani."
      okBtnText="Briši"
      v-model="showDeleteUserTypeModal"
      @confirmed="remove(deleteUserType)"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import asyncDataStatus from '@/mixins/asyncDataStatus'
import { siIncludes } from '@/utils/str'
import { loadItems, deleteItem } from '@/utils/crudFunctions'
import UserTypeCard from '@/components/UserTypeCard'
import ConfirmDialog from '@/components/ConfirmDialog'
import { objectToArray } from '@/utils/object'

export default {
  components: {
    UserTypeCard,
    ConfirmDialog
  },
  mixins: [
    asyncDataStatus
  ],
  data () {
    return {
      filter: '',
      showDeleteUserTypeModal: false,
      deleteUserType: null
    }
  },
  computed: {
    userTypes () {
      return objectToArray(this.$store.state.userTypes.items)
    },
    filteredUserTypes () {
      return this.userTypes.filter(item => siIncludes({ haystack: item.name, needle: this.filter }))
    }
  },
  methods: {
    ...mapActions('userTypes', ['loadItems', 'deleteItem']),
    ...mapActions('settings', ['loadGlobalSettings']),
    remove (item) {
      deleteItem(item, this)
    }
  },
  created () {
    loadItems(this)
    this.loadGlobalSettings()
  }
}
</script>

<style scoped>

  @media (max-width: 600px) {
    .userTypes-wrapper {
      flex-direction: column;
    }
  }
</style>
